// Este arquivo é gerado automaticamente. NÃO edite manualmente.

import * as Icons from './svgr/Icons';

export const iconMap = {
  "access-alarm-filled": Icons.AccessAlarmFilled,
  "accessibility-default": Icons.AccessibilityDefault,
  "accessibility-filled": Icons.AccessibilityFilled,
  "accessible-filled": Icons.AccessibleFilled,
  "access-phone": Icons.AccessPhone,
  "account-balance-default": Icons.AccountBalanceDefault,
  "account-balance-wallet-filled": Icons.AccountBalanceWalletFilled,
  "account-circle-filled": Icons.AccountCircleFilled,
  "acessibility-default": Icons.AcessibilityDefault,
  "add-circle-default": Icons.AddCircleDefault,
  "add-default": Icons.AddDefault,
  "add-filled": Icons.AddFilled,
  "add-location-filled": Icons.AddLocationFilled,
  "add-reaction-filled": Icons.AddReactionFilled,
  "agender": Icons.Agender,
  "ai-camera-filled": Icons.AiCameraFilled,
  "ai-upload-file-filled": Icons.AiUploadFileFilled,
  "alarm-add": Icons.AlarmAdd,
  "alarm-blocked": Icons.AlarmBlocked,
  "alarm-checked": Icons.AlarmChecked,
  "alarm-default": Icons.AlarmDefault,
  "alarm-more": Icons.AlarmMore,
  "apple-filled": Icons.AppleFilled,
  "appointments-alert": Icons.AppointmentsAlert,
  "apps-filled": Icons.AppsFilled,
  "app-shortcut-filled": Icons.AppShortcutFilled,
  "arrow-back": Icons.ArrowBack,
  "arrow-circle": Icons.ArrowCircle,
  "arrow-circle-down": Icons.ArrowCircleDown,
  "arrow-circle-left": Icons.ArrowCircleLeft,
  "arrow-circle-right": Icons.ArrowCircleRight,
  "arrow-circle-up": Icons.ArrowCircleUp,
  "arrow-down": Icons.ArrowDown,
  "arrow-down-filled": Icons.ArrowDownFilled,
  "arrow-drop-down": Icons.ArrowDropDown,
  "arrow-drop-left": Icons.ArrowDropLeft,
  "arrow-drop-right": Icons.ArrowDropRight,
  "arrow-drop-up": Icons.ArrowDropUp,
  "arrow-left-filled": Icons.ArrowLeftFilled,
  "arrow-right": Icons.ArrowRight,
  "arrow-right-filled": Icons.ArrowRightFilled,
  "arrow-up": Icons.ArrowUp,
  "arrow-up-filled": Icons.ArrowUpFilled,
  "article-person-filled": Icons.ArticlePersonFilled,
  "article-person-outlined": Icons.ArticlePersonOutlined,
  "article-shortcut": Icons.ArticleShortcut,
  "assignment-default": Icons.AssignmentDefault,
  "assignment-filled": Icons.AssignmentFilled,
  "assignment-lnd-filled": Icons.AssignmentLndFilled,
  "assignment-outline": Icons.AssignmentOutline,
  "attach-file-filled": Icons.AttachFileFilled,
  "attach-money-filled": Icons.AttachMoneyFilled,
  "autoawsome": Icons.Autoawsome,
  "backlight-off": Icons.BacklightOff,
  "barcode-default": Icons.BarcodeDefault,
  "basket": Icons.Basket,
  "bell": Icons.Bell,
  "ben-export": Icons.BenExport,
  "ben-mail-outline-filled": Icons.BenMailOutlineFilled,
  "block-filled": Icons.BlockFilled,
  "books-filled": Icons.BooksFilled,
  "brl-icon": Icons.BrlIcon,
  "bug-report-filled": Icons.BugReportFilled,
  "building-outline": Icons.BuildingOutline,
  "cached-default": Icons.CachedDefault,
  "cake-outlined": Icons.CakeOutlined,
  "calendar-add": Icons.CalendarAdd,
  "calendar-add-filled": Icons.CalendarAddFilled,
  "calendar-alert": Icons.CalendarAlert,
  "calendar-check": Icons.CalendarCheck,
  "calendar-checked": Icons.CalendarChecked,
  "calendar-clock": Icons.CalendarClock,
  "calendar-default": Icons.CalendarDefault,
  "calendar-edit": Icons.CalendarEdit,
  "calendar-error": Icons.CalendarError,
  "calendar-focused": Icons.CalendarFocused,
  "calendar-focused-filled": Icons.CalendarFocusedFilled,
  "calendar-more": Icons.CalendarMore,
  "calendar-range": Icons.CalendarRange,
  "calendar-today-filled": Icons.CalendarTodayFilled,
  "camera": Icons.Camera,
  "camera-alt-filled": Icons.CameraAltFilled,
  "campaign-filled": Icons.CampaignFilled,
  "cancel-filled": Icons.CancelFilled,
  "cardiology": Icons.Cardiology,
  "card-user-mold": Icons.CardUserMold,
  "caret-left": Icons.CaretLeft,
  "caret-right": Icons.CaretRight,
  "car-filled": Icons.CarFilled,
  "chat-filled": Icons.ChatFilled,
  "check-circle-filled": Icons.CheckCircleFilled,
  "check-circle-outline-filled": Icons.CheckCircleOutlineFilled,
  "check-default": Icons.CheckDefault,
  "chevron-left-outlined": Icons.ChevronLeftOutlined,
  "chevron-right-outlined": Icons.ChevronRightOutlined,
  "child-care": Icons.ChildCare,
  "circular-star": Icons.CircularStar,
  "clinical-notes-default": Icons.ClinicalNotesDefault,
  "clipboard-check-outline": Icons.ClipboardCheckOutline,
  "clipboard-plus-outline": Icons.ClipboardPlusOutline,
  "clipboard-pulse-outline": Icons.ClipboardPulseOutline,
  "clipboard-text-clock-outline": Icons.ClipboardTextClockOutline,
  "clock-filled": Icons.ClockFilled,
  "close-default": Icons.CloseDefault,
  "closed-padlock": Icons.ClosedPadlock,
  "close-filled": Icons.CloseFilled,
  "cognition": Icons.Cognition,
  "comment-default": Icons.CommentDefault,
  "computer-filled": Icons.ComputerFilled,
  "concierge": Icons.Concierge,
  "content-copy-filled": Icons.ContentCopyFilled,
  "content-paste-filled": Icons.ContentPasteFilled,
  "content-paste-search-filled": Icons.ContentPasteSearchFilled,
  "contract-default": Icons.ContractDefault,
  "contract-edit": Icons.ContractEdit,
  "contract-error": Icons.ContractError,
  "copy-default": Icons.CopyDefault,
  "credit-card-blocked": Icons.CreditCardBlocked,
  "credit-card-checked": Icons.CreditCardChecked,
  "credit-card-default": Icons.CreditCardDefault,
  "currency-exchange-filled": Icons.CurrencyExchangeFilled,
  "data-loss": Icons.DataLoss,
  "delete-outline-filled": Icons.DeleteOutlineFilled,
  "dentist-default": Icons.DentistDefault,
  "dermatology": Icons.Dermatology,
  "dialog-filled": Icons.DialogFilled,
  "directions": Icons.Directions,
  "directions-run": Icons.DirectionsRun,
  "disabled-by-default-filled": Icons.DisabledByDefaultFilled,
  "doctor-filled": Icons.DoctorFilled,
  "document-default": Icons.DocumentDefault,
  "document-edit": Icons.DocumentEdit,
  "document-heart-outlined": Icons.DocumentHeartOutlined,
  "document-scanner": Icons.DocumentScanner,
  "document-scanner-filled": Icons.DocumentScannerFilled,
  "document-tooth-outlined": Icons.DocumentToothOutlined,
  "download": Icons.Download,
  "download-default": Icons.DownloadDefault,
  "download-file": Icons.DownloadFile,
  "drag-indicator": Icons.DragIndicator,
  "drawer": Icons.Drawer,
  "edit": Icons.Edit,
  "edit-default": Icons.EditDefault,
  "emoji-people-filled": Icons.EmojiPeopleFilled,
  "emoticon-angry-outline": Icons.EmoticonAngryOutline,
  "emoticon-excited": Icons.EmoticonExcited,
  "emoticon-happy-outline": Icons.EmoticonHappyOutline,
  "emoticon-neutral-outline": Icons.EmoticonNeutralOutline,
  "emoticon-outline": Icons.EmoticonOutline,
  "emoticon-sad-outline": Icons.EmoticonSadOutline,
  "empty-state-lens": Icons.EmptyStateLens,
  "error-fill": Icons.ErrorFill,
  "error-outline": Icons.ErrorOutline,
  "event-filled": Icons.EventFilled,
  "event-note-filled": Icons.EventNoteFilled,
  "event-repeat": Icons.EventRepeat,
  "exclamation-default": Icons.ExclamationDefault,
  "exit-default": Icons.ExitDefault,
  "exit-to-app-filled": Icons.ExitToAppFilled,
  "expand-down": Icons.ExpandDown,
  "expand-less-filled": Icons.ExpandLessFilled,
  "expand-more-filled": Icons.ExpandMoreFilled,
  "expand-up": Icons.ExpandUp,
  "external-link-default": Icons.ExternalLinkDefault,
  "extract": Icons.Extract,
  "face": Icons.Face,
  "face-focus": Icons.FaceFocus,
  "face-left": Icons.FaceLeft,
  "face-right": Icons.FaceRight,
  "facial-recognition": Icons.FacialRecognition,
  "feedback-default": Icons.FeedbackDefault,
  "file": Icons.File,
  "file-attach-outlined": Icons.FileAttachOutlined,
  "file-check-outline": Icons.FileCheckOutline,
  "file-default": Icons.FileDefault,
  "file-document-outline": Icons.FileDocumentOutline,
  "filter-app": Icons.FilterApp,
  "finger-print": Icons.FingerPrint,
  "fingerprint-default": Icons.FingerprintDefault,
  "fluid-default": Icons.FluidDefault,
  "folder-add": Icons.FolderAdd,
  "folder-edit": Icons.FolderEdit,
  "gavel-filled": Icons.GavelFilled,
  "globe": Icons.Globe,
  "google-calendar": Icons.GoogleCalendar,
  "group-add": Icons.GroupAdd,
  "group-filled": Icons.GroupFilled,
  "group-remove": Icons.GroupRemove,
  "hapvida-logo": Icons.HapvidaLogo,
  "headphones": Icons.Headphones,
  "health-metrics": Icons.HealthMetrics,
  "hearing-disabled-filled": Icons.HearingDisabledFilled,
  "heart-filled": Icons.HeartFilled,
  "heart-outline": Icons.HeartOutline,
  "help-default": Icons.HelpDefault,
  "help-filled": Icons.HelpFilled,
  "help-outline-filled": Icons.HelpOutlineFilled,
  "hideimage-default": Icons.HideimageDefault,
  "history-clock": Icons.HistoryClock,
  "home-filled": Icons.HomeFilled,
  "hospital-hapvida-outlined": Icons.HospitalHapvidaOutlined,
  "hotel-bed-line": Icons.HotelBedLine,
  "icon-grid": Icons.IconGrid,
  "id-card": Icons.IdCard,
  "image-not-supported-filled": Icons.ImageNotSupportedFilled,
  "inbox-filled": Icons.InboxFilled,
  "info-default": Icons.InfoDefault,
  "info-filled": Icons.InfoFilled,
  "info-outlined": Icons.InfoOutlined,
  "insert-comment-filled": Icons.InsertCommentFilled,
  "insert-drive-file-filled": Icons.InsertDriveFileFilled,
  "join-left-filled": Icons.JoinLeftFilled,
  "key": Icons.Key,
  "keyboard-filled": Icons.KeyboardFilled,
  "key-filled": Icons.KeyFilled,
  "landscape": Icons.Landscape,
  "laptop-chromebook-filled": Icons.LaptopChromebookFilled,
  "less-default": Icons.LessDefault,
  "link-outlined": Icons.LinkOutlined,
  "lion-filled": Icons.LionFilled,
  "list-filled": Icons.ListFilled,
  "live-help-filled": Icons.LiveHelpFilled,
  "local-hospital-day-outline": Icons.LocalHospitalDayOutline,
  "local-hospital-filled": Icons.LocalHospitalFilled,
  "local-hospital-night-outline": Icons.LocalHospitalNightOutline,
  "local-hospital-outline": Icons.LocalHospitalOutline,
  "location-add": Icons.LocationAdd,
  "location-add-filled": Icons.LocationAddFilled,
  "location-blocked": Icons.LocationBlocked,
  "location-default": Icons.LocationDefault,
  "location-edit": Icons.LocationEdit,
  "location-on-filled": Icons.LocationOnFilled,
  "lock-circle-filled": Icons.LockCircleFilled,
  "lock-default": Icons.LockDefault,
  "log-in": Icons.LogIn,
  "mail-default": Icons.MailDefault,
  "mail-filled": Icons.MailFilled,
  "mall-default": Icons.MallDefault,
  "manage-account-filled": Icons.ManageAccountFilled,
  "manage-search-filled": Icons.ManageSearchFilled,
  "map": Icons.Map,
  "map-default": Icons.MapDefault,
  "mark-as-read": Icons.MarkAsRead,
  "mark-as-unread": Icons.MarkAsUnread,
  "masks-filled": Icons.MasksFilled,
  "medical-file-outline": Icons.MedicalFileOutline,
  "medical-information": Icons.MedicalInformation,
  "medicalinformation-default": Icons.MedicalinformationDefault,
  "medical-services-default": Icons.MedicalServicesDefault,
  "medical-services-filled": Icons.MedicalServicesFilled,
  "medication-filled": Icons.MedicationFilled,
  "menu-book-filled": Icons.MenuBookFilled,
  "monetization-on-filled": Icons.MonetizationOnFilled,
  "monitor-heart-filled": Icons.MonitorHeartFilled,
  "moon": Icons.Moon,
  "mop-outline": Icons.MopOutline,
  "more-horiz-filled": Icons.MoreHorizFilled,
  "my-location-filled": Icons.MyLocationFilled,
  "navbar-benefits-default-small": Icons.NavbarBenefitsDefaultSmall,
  "navbar-calendar-add-small": Icons.NavbarCalendarAddSmall,
  "navbar-home-default-small": Icons.NavbarHomeDefaultSmall,
  "navbar-identity-default-small": Icons.NavbarIdentityDefaultSmall,
  "navbar-widgets-default-small": Icons.NavbarWidgetsDefaultSmall,
  "near-me-filled": Icons.NearMeFilled,
  "needle": Icons.Needle,
  "note": Icons.Note,
  "notes-filled": Icons.NotesFilled,
  "notification-default": Icons.NotificationDefault,
  "notifications-filled": Icons.NotificationsFilled,
  "notredame-logo": Icons.NotredameLogo,
  "odonto-exchange-filled": Icons.OdontoExchangeFilled,
  "outgoing-mail-filled": Icons.OutgoingMailFilled,
  "outlook": Icons.Outlook,
  "paid": Icons.Paid,
  "paper-airplane": Icons.PaperAirplane,
  "password-default": Icons.PasswordDefault,
  "password-info-filled": Icons.PasswordInfoFilled,
  "pending-action": Icons.PendingAction,
  "percent": Icons.Percent,
  "percent-discount": Icons.PercentDiscount,
  "perm-contact-callendar-filled": Icons.PermContactCallendarFilled,
  "perm-device-information-filled": Icons.PermDeviceInformationFilled,
  "person-add": Icons.PersonAdd,
  "person-filled": Icons.PersonFilled,
  "person-outline": Icons.PersonOutline,
  "person-search": Icons.PersonSearch,
  "phone-add-filled": Icons.PhoneAddFilled,
  "phone-android-filled": Icons.PhoneAndroidFilled,
  "phone-filled": Icons.PhoneFilled,
  "picture-as-pdf-filled": Icons.PictureAsPdfFilled,
  "pills-default": Icons.PillsDefault,
  "pin-drop-filled": Icons.PinDropFilled,
  "pizza-chart": Icons.PizzaChart,
  "plane-contrails": Icons.PlaneContrails,
  "play-circle-filled": Icons.PlayCircleFilled,
  "position-default": Icons.PositionDefault,
  "position-focused": Icons.PositionFocused,
  "prescriptions-default": Icons.PrescriptionsDefault,
  "price-check-filled": Icons.PriceCheckFilled,
  "price-clock-filled": Icons.PriceClockFilled,
  "profile-default": Icons.ProfileDefault,
  "query-builder-filled": Icons.QueryBuilderFilled,
  "radiology-box": Icons.RadiologyBox,
  "radiology-default": Icons.RadiologyDefault,
  "reaction-add": Icons.ReactionAdd,
  "receipt": Icons.Receipt,
  "receipt-default": Icons.ReceiptDefault,
  "receipt-long-filled": Icons.ReceiptLongFilled,
  "reload": Icons.Reload,
  "remember-me-filled": Icons.RememberMeFilled,
  "replace-default": Icons.ReplaceDefault,
  "report": Icons.Report,
  "reset-lock-default": Icons.ResetLockDefault,
  "rounded-star-filled": Icons.RoundedStarFilled,
  "rounded-star-outlined": Icons.RoundedStarOutlined,
  "screen-search-default": Icons.ScreenSearchDefault,
  "search-default": Icons.SearchDefault,
  "search-lens": Icons.SearchLens,
  "search-off-filled": Icons.SearchOffFilled,
  "sell-filled": Icons.SellFilled,
  "settings": Icons.Settings,
  "share-filled": Icons.ShareFilled,
  "share-outline": Icons.ShareOutline,
  "share-outlined": Icons.ShareOutlined,
  "shield-encrypted": Icons.ShieldEncrypted,
  "shield-health-outlined": Icons.ShieldHealthOutlined,
  "shield-lock": Icons.ShieldLock,
  "sick": Icons.Sick,
  "signal-cellular-connected": Icons.SignalCellularConnected,
  "smartphone-avatar": Icons.SmartphoneAvatar,
  "smartphone-blocked": Icons.SmartphoneBlocked,
  "smartphone-checked": Icons.SmartphoneChecked,
  "smartphone-default": Icons.SmartphoneDefault,
  "smartphone-down": Icons.SmartphoneDown,
  "smartphone-filled": Icons.SmartphoneFilled,
  "smartphone-focused": Icons.SmartphoneFocused,
  "smartphone-right": Icons.SmartphoneRight,
  "smartphone-success": Icons.SmartphoneSuccess,
  "social-distance-filled": Icons.SocialDistanceFilled,
  "source-filled": Icons.SourceFilled,
  "spinner-loading": Icons.SpinnerLoading,
  "stamp-default": Icons.StampDefault,
  "star-filled": Icons.StarFilled,
  "star-outline-filled": Icons.StarOutlineFilled,
  "stethoscope": Icons.Stethoscope,
  "stethoscope-arrow": Icons.StethoscopeArrow,
  "stethoscope-default": Icons.StethoscopeDefault,
  "stopwatch": Icons.Stopwatch,
  "success": Icons.Success,
  "success-date": Icons.SuccessDate,
  "sun": Icons.Sun,
  "sunny": Icons.Sunny,
  "surgical": Icons.Surgical,
  "syringe-default": Icons.SyringeDefault,
  "table-rows-filled": Icons.TableRowsFilled,
  "table-view-filled": Icons.TableViewFilled,
  "tag-filled": Icons.TagFilled,
  "task-alt-filled": Icons.TaskAltFilled,
  "task-filled": Icons.TaskFilled,
  "telephone-default": Icons.TelephoneDefault,
  "text-box-outline": Icons.TextBoxOutline,
  "thumb-down-filled": Icons.ThumbDownFilled,
  "thumb-up-filled": Icons.ThumbUpFilled,
  "time-default": Icons.TimeDefault,
  "timelapse-filled": Icons.TimelapseFilled,
  "tooth-outline": Icons.ToothOutline,
  "undo": Icons.Undo,
  "upload-file-filled": Icons.UploadFileFilled,
  "user-check": Icons.UserCheck,
  "user-leaving": Icons.UserLeaving,
  "verified-user": Icons.VerifiedUser,
  "video": Icons.Video,
  "video-camera-front-filled": Icons.VideoCameraFrontFilled,
  "video-default": Icons.VideoDefault,
  "visibility-blocked": Icons.VisibilityBlocked,
  "visibility-default": Icons.VisibilityDefault,
  "visibility-filled": Icons.VisibilityFilled,
  "visibility-off-filled": Icons.VisibilityOffFilled,
  "warning": Icons.Warning,
  "warning-outlined": Icons.WarningOutlined,
  "weather-night": Icons.WeatherNight,
  "weather-sunset": Icons.WeatherSunset,
  "website-outline": Icons.WebsiteOutline,
  "whatsapp-filled": Icons.WhatsappFilled,
  "zoom-in": Icons.ZoomIn,
  "zoom-out": Icons.ZoomOut,
};

type IconNamesType =
  | 'access-alarm-filled'
  | 'accessibility-default'
  | 'accessibility-filled'
  | 'accessible-filled'
  | 'access-phone'
  | 'account-balance-default'
  | 'account-balance-wallet-filled'
  | 'account-circle-filled'
  | 'acessibility-default'
  | 'add-circle-default'
  | 'add-default'
  | 'add-filled'
  | 'add-location-filled'
  | 'add-reaction-filled'
  | 'agender'
  | 'ai-camera-filled'
  | 'ai-upload-file-filled'
  | 'alarm-add'
  | 'alarm-blocked'
  | 'alarm-checked'
  | 'alarm-default'
  | 'alarm-more'
  | 'apple-filled'
  | 'appointments-alert'
  | 'apps-filled'
  | 'app-shortcut-filled'
  | 'arrow-back'
  | 'arrow-circle'
  | 'arrow-circle-down'
  | 'arrow-circle-left'
  | 'arrow-circle-right'
  | 'arrow-circle-up'
  | 'arrow-down'
  | 'arrow-down-filled'
  | 'arrow-drop-down'
  | 'arrow-drop-left'
  | 'arrow-drop-right'
  | 'arrow-drop-up'
  | 'arrow-left-filled'
  | 'arrow-right'
  | 'arrow-right-filled'
  | 'arrow-up'
  | 'arrow-up-filled'
  | 'article-person-filled'
  | 'article-person-outlined'
  | 'article-shortcut'
  | 'assignment-default'
  | 'assignment-filled'
  | 'assignment-lnd-filled'
  | 'assignment-outline'
  | 'attach-file-filled'
  | 'attach-money-filled'
  | 'autoawsome'
  | 'backlight-off'
  | 'barcode-default'
  | 'basket'
  | 'bell'
  | 'ben-export'
  | 'ben-mail-outline-filled'
  | 'block-filled'
  | 'books-filled'
  | 'brl-icon'
  | 'bug-report-filled'
  | 'building-outline'
  | 'cached-default'
  | 'cake-outlined'
  | 'calendar-add'
  | 'calendar-add-filled'
  | 'calendar-alert'
  | 'calendar-check'
  | 'calendar-checked'
  | 'calendar-clock'
  | 'calendar-default'
  | 'calendar-edit'
  | 'calendar-error'
  | 'calendar-focused'
  | 'calendar-focused-filled'
  | 'calendar-more'
  | 'calendar-range'
  | 'calendar-today-filled'
  | 'camera'
  | 'camera-alt-filled'
  | 'campaign-filled'
  | 'cancel-filled'
  | 'cardiology'
  | 'card-user-mold'
  | 'caret-left'
  | 'caret-right'
  | 'car-filled'
  | 'chat-filled'
  | 'check-circle-filled'
  | 'check-circle-outline-filled'
  | 'check-default'
  | 'chevron-left-outlined'
  | 'chevron-right-outlined'
  | 'child-care'
  | 'circular-star'
  | 'clinical-notes-default'
  | 'clipboard-check-outline'
  | 'clipboard-plus-outline'
  | 'clipboard-pulse-outline'
  | 'clipboard-text-clock-outline'
  | 'clock-filled'
  | 'close-default'
  | 'closed-padlock'
  | 'close-filled'
  | 'cognition'
  | 'comment-default'
  | 'computer-filled'
  | 'concierge'
  | 'content-copy-filled'
  | 'content-paste-filled'
  | 'content-paste-search-filled'
  | 'contract-default'
  | 'contract-edit'
  | 'contract-error'
  | 'copy-default'
  | 'credit-card-blocked'
  | 'credit-card-checked'
  | 'credit-card-default'
  | 'currency-exchange-filled'
  | 'data-loss'
  | 'delete-outline-filled'
  | 'dentist-default'
  | 'dermatology'
  | 'dialog-filled'
  | 'directions'
  | 'directions-run'
  | 'disabled-by-default-filled'
  | 'doctor-filled'
  | 'document-default'
  | 'document-edit'
  | 'document-heart-outlined'
  | 'document-scanner'
  | 'document-scanner-filled'
  | 'document-tooth-outlined'
  | 'download'
  | 'download-default'
  | 'download-file'
  | 'drag-indicator'
  | 'drawer'
  | 'edit'
  | 'edit-default'
  | 'emoji-people-filled'
  | 'emoticon-angry-outline'
  | 'emoticon-excited'
  | 'emoticon-happy-outline'
  | 'emoticon-neutral-outline'
  | 'emoticon-outline'
  | 'emoticon-sad-outline'
  | 'empty-state-lens'
  | 'error-fill'
  | 'error-outline'
  | 'event-filled'
  | 'event-note-filled'
  | 'event-repeat'
  | 'exclamation-default'
  | 'exit-default'
  | 'exit-to-app-filled'
  | 'expand-down'
  | 'expand-less-filled'
  | 'expand-more-filled'
  | 'expand-up'
  | 'external-link-default'
  | 'extract'
  | 'face'
  | 'face-focus'
  | 'face-left'
  | 'face-right'
  | 'facial-recognition'
  | 'feedback-default'
  | 'file'
  | 'file-attach-outlined'
  | 'file-check-outline'
  | 'file-default'
  | 'file-document-outline'
  | 'filter-app'
  | 'finger-print'
  | 'fingerprint-default'
  | 'fluid-default'
  | 'folder-add'
  | 'folder-edit'
  | 'gavel-filled'
  | 'globe'
  | 'google-calendar'
  | 'group-add'
  | 'group-filled'
  | 'group-remove'
  | 'hapvida-logo'
  | 'headphones'
  | 'health-metrics'
  | 'hearing-disabled-filled'
  | 'heart-filled'
  | 'heart-outline'
  | 'help-default'
  | 'help-filled'
  | 'help-outline-filled'
  | 'hideimage-default'
  | 'history-clock'
  | 'home-filled'
  | 'hospital-hapvida-outlined'
  | 'hotel-bed-line'
  | 'icon-grid'
  | 'id-card'
  | 'image-not-supported-filled'
  | 'inbox-filled'
  | 'info-default'
  | 'info-filled'
  | 'info-outlined'
  | 'insert-comment-filled'
  | 'insert-drive-file-filled'
  | 'join-left-filled'
  | 'key'
  | 'keyboard-filled'
  | 'key-filled'
  | 'landscape'
  | 'laptop-chromebook-filled'
  | 'less-default'
  | 'link-outlined'
  | 'lion-filled'
  | 'list-filled'
  | 'live-help-filled'
  | 'local-hospital-day-outline'
  | 'local-hospital-filled'
  | 'local-hospital-night-outline'
  | 'local-hospital-outline'
  | 'location-add'
  | 'location-add-filled'
  | 'location-blocked'
  | 'location-default'
  | 'location-edit'
  | 'location-on-filled'
  | 'lock-circle-filled'
  | 'lock-default'
  | 'log-in'
  | 'mail-default'
  | 'mail-filled'
  | 'mall-default'
  | 'manage-account-filled'
  | 'manage-search-filled'
  | 'map'
  | 'map-default'
  | 'mark-as-read'
  | 'mark-as-unread'
  | 'masks-filled'
  | 'medical-file-outline'
  | 'medical-information'
  | 'medicalinformation-default'
  | 'medical-services-default'
  | 'medical-services-filled'
  | 'medication-filled'
  | 'menu-book-filled'
  | 'monetization-on-filled'
  | 'monitor-heart-filled'
  | 'moon'
  | 'mop-outline'
  | 'more-horiz-filled'
  | 'my-location-filled'
  | 'navbar-benefits-default-small'
  | 'navbar-calendar-add-small'
  | 'navbar-home-default-small'
  | 'navbar-identity-default-small'
  | 'navbar-widgets-default-small'
  | 'near-me-filled'
  | 'needle'
  | 'note'
  | 'notes-filled'
  | 'notification-default'
  | 'notifications-filled'
  | 'notredame-logo'
  | 'odonto-exchange-filled'
  | 'outgoing-mail-filled'
  | 'outlook'
  | 'paid'
  | 'paper-airplane'
  | 'password-default'
  | 'password-info-filled'
  | 'pending-action'
  | 'percent'
  | 'percent-discount'
  | 'perm-contact-callendar-filled'
  | 'perm-device-information-filled'
  | 'person-add'
  | 'person-filled'
  | 'person-outline'
  | 'person-search'
  | 'phone-add-filled'
  | 'phone-android-filled'
  | 'phone-filled'
  | 'picture-as-pdf-filled'
  | 'pills-default'
  | 'pin-drop-filled'
  | 'pizza-chart'
  | 'plane-contrails'
  | 'play-circle-filled'
  | 'position-default'
  | 'position-focused'
  | 'prescriptions-default'
  | 'price-check-filled'
  | 'price-clock-filled'
  | 'profile-default'
  | 'query-builder-filled'
  | 'radiology-box'
  | 'radiology-default'
  | 'reaction-add'
  | 'receipt'
  | 'receipt-default'
  | 'receipt-long-filled'
  | 'reload'
  | 'remember-me-filled'
  | 'replace-default'
  | 'report'
  | 'reset-lock-default'
  | 'rounded-star-filled'
  | 'rounded-star-outlined'
  | 'screen-search-default'
  | 'search-default'
  | 'search-lens'
  | 'search-off-filled'
  | 'sell-filled'
  | 'settings'
  | 'share-filled'
  | 'share-outline'
  | 'share-outlined'
  | 'shield-encrypted'
  | 'shield-health-outlined'
  | 'shield-lock'
  | 'sick'
  | 'signal-cellular-connected'
  | 'smartphone-avatar'
  | 'smartphone-blocked'
  | 'smartphone-checked'
  | 'smartphone-default'
  | 'smartphone-down'
  | 'smartphone-filled'
  | 'smartphone-focused'
  | 'smartphone-right'
  | 'smartphone-success'
  | 'social-distance-filled'
  | 'source-filled'
  | 'spinner-loading'
  | 'stamp-default'
  | 'star-filled'
  | 'star-outline-filled'
  | 'stethoscope'
  | 'stethoscope-arrow'
  | 'stethoscope-default'
  | 'stopwatch'
  | 'success'
  | 'success-date'
  | 'sun'
  | 'sunny'
  | 'surgical'
  | 'syringe-default'
  | 'table-rows-filled'
  | 'table-view-filled'
  | 'tag-filled'
  | 'task-alt-filled'
  | 'task-filled'
  | 'telephone-default'
  | 'text-box-outline'
  | 'thumb-down-filled'
  | 'thumb-up-filled'
  | 'time-default'
  | 'timelapse-filled'
  | 'tooth-outline'
  | 'undo'
  | 'upload-file-filled'
  | 'user-check'
  | 'user-leaving'
  | 'verified-user'
  | 'video'
  | 'video-camera-front-filled'
  | 'video-default'
  | 'visibility-blocked'
  | 'visibility-default'
  | 'visibility-filled'
  | 'visibility-off-filled'
  | 'warning'
  | 'warning-outlined'
  | 'weather-night'
  | 'weather-sunset'
  | 'website-outline'
  | 'whatsapp-filled'
  | 'zoom-in'
  | 'zoom-out'

export default IconNamesType;
